import { httpRequest } from "@services/http";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetSerializer } from "@models/serializers/pricesheetSerializer";

export interface UpdatePricesheetPayload {
  base_price?: number;
  is_active?: boolean;
}

export class CommandUpdatePricesheet {
  async run(contractId: number, pricesheetId: number, payload: UpdatePricesheetPayload): Promise<Pricesheet> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return PricesheetSerializer.fromJson(response);
  }
}
